(() => {
  const roots = document.querySelectorAll('[data-flash-piece]');
  if (!roots.length) return;

  const getZonedParts = (date, timeZone) => {
    const formatter = new Intl.DateTimeFormat('en-CA', {
      timeZone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hourCycle: 'h23',
    });

    return formatter.formatToParts(date).reduce((parts, part) => {
      if (part.type !== 'literal') parts[part.type] = Number(part.value);
      return parts;
    }, {});
  };

  const getTimeZoneOffset = (date, timeZone) => {
    const parts = getZonedParts(date, timeZone);

    const zonedAsUTC = Date.UTC(
      parts.year,
      parts.month - 1,
      parts.day,
      parts.hour,
      parts.minute,
      parts.second
    );

    return zonedAsUTC - date.getTime();
  };

  const zonedDateToUtc = (parts, timeZone) => {
    const guessedUTC = Date.UTC(
      parts.year,
      parts.month - 1,
      parts.day,
      parts.hour,
      parts.minute,
      parts.second
    );

    let offset = getTimeZoneOffset(new Date(guessedUTC), timeZone);
    let result = guessedUTC - offset;
    const correctedOffset = getTimeZoneOffset(new Date(result), timeZone);

    if (correctedOffset !== offset) result = guessedUTC - correctedOffset;

    return new Date(result);
  };

  const pad = (value) =>
    String(Math.max(0, Math.floor(value))).padStart(2, '0');

  const hms = (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;

    return `${pad(hours)}:${pad(minutes)}:${pad(secs)}`;
  };

  roots.forEach((root) => {
    const discount = Number(root.dataset.discount || 0);
    const currency = root.dataset.currency || 'EUR';
    const locale = root.dataset.locale || 'es-ES';
    const timeZone = root.dataset.timezone || 'Europe/Madrid';

    const hero = root.querySelector('[data-flash-hero]');
    const sticky = root.querySelector('[data-flash-sticky]');
    const variantSelect = root.querySelector('[data-flash-variant]');

    const hoursNodes = root.querySelectorAll('[data-flash-hours]');
    const minutesNodes = root.querySelectorAll('[data-flash-minutes]');
    const secondsNodes = root.querySelectorAll('[data-flash-seconds]');

    const progressNodes = root.querySelectorAll('[data-flash-progress]');
    const inlineTimerNodes = root.querySelectorAll(
      '[data-flash-inline-timer]'
    );
    const stickyTimerNodes = root.querySelectorAll(
      '[data-flash-sticky-timer]'
    );
    const nextTimerNodes = root.querySelectorAll(
      '[data-flash-next-counter]'
    );

    const priceNodes = root.querySelectorAll('[data-flash-price]');
    const originalPriceNodes = root.querySelectorAll(
      '[data-flash-original-price]'
    );

    const actionButtons = root.querySelectorAll(
      '[data-flash-add-button]'
    );

    const reveals = root.querySelectorAll('[data-flash-reveal]');

    const money = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    const formatMoney = (cents) => money.format(Number(cents) / 100);

    const updatePrices = (originalCents, discountedCents) => {
      originalPriceNodes.forEach((node) => {
        node.textContent = formatMoney(originalCents);
      });

      priceNodes.forEach((node) => {
        node.textContent = formatMoney(discountedCents);
      });
    };

    const updateActionState = (available) => {
      const addLabel = root.dataset.addLabel || 'Añadir al carrito';
      const soldOutLabel = root.dataset.soldoutLabel || 'Agotado';

      actionButtons.forEach((button) => {
        const disabled =
          root.classList.contains('is-expired') || !available;

        button.disabled = disabled;
        button.setAttribute('aria-disabled', String(disabled));

        const label = button.querySelector(
          '[data-flash-button-label]'
        );

        if (label) {
          label.textContent = available ? addLabel : soldOutLabel;
        }
      });
    };

    const updateVariant = () => {
      if (!variantSelect) return;

      const selected = variantSelect.options[variantSelect.selectedIndex];
      const originalPrice = Number(selected.dataset.price || 0);

      const flashPrice = Number(
        selected.dataset.flashPrice ||
          Math.round((originalPrice * (100 - discount)) / 100)
      );

      const available = selected.dataset.available === 'true';

      updatePrices(originalPrice, flashPrice);
      updateActionState(available);
    };

    if (variantSelect) {
      variantSelect.addEventListener('change', updateVariant);
      updateVariant();
    }

    const currentMadridParts = getZonedParts(new Date(), timeZone);

    const offerStart = zonedDateToUtc(
      {
        year: currentMadridParts.year,
        month: currentMadridParts.month,
        day: currentMadridParts.day,
        hour: 0,
        minute: 0,
        second: 0,
      },
      timeZone
    );

    const offerEnd = zonedDateToUtc(
      {
        year: currentMadridParts.year,
        month: currentMadridParts.month,
        day: currentMadridParts.day,
        hour: 23,
        minute: 59,
        second: 59,
      },
      timeZone
    );

    const totalMilliseconds = Math.max(
      1,
      offerEnd.getTime() - offerStart.getTime()
    );

    let intervalId;

    const setExpired = () => {
      root.classList.add('is-expired');

      updateActionState(false);

      progressNodes.forEach((node) => {
        node.style.width = '0%';
      });

      stickyTimerNodes.forEach((node) => {
        node.textContent = '00:00:00';
      });

      if (intervalId) window.clearInterval(intervalId);
    };

    const updateCountdown = () => {
      const remainingMilliseconds = offerEnd.getTime() - Date.now();

      const remainingSeconds = Math.max(
        0,
        Math.ceil(remainingMilliseconds / 1000)
      );

      if (remainingSeconds <= 0) {
        setExpired();
        return;
      }

      const hours = Math.floor(remainingSeconds / 3600);
      const minutes = Math.floor(
        (remainingSeconds % 3600) / 60
      );
      const seconds = remainingSeconds % 60;

      const progress = Math.max(
        0,
        Math.min(
          100,
          (remainingMilliseconds / totalMilliseconds) * 100
        )
      );

      const formatted = hms(remainingSeconds);

      hoursNodes.forEach((node) => {
        node.textContent = pad(hours);
      });

      minutesNodes.forEach((node) => {
        node.textContent = pad(minutes);
      });

      secondsNodes.forEach((node) => {
        node.textContent = pad(seconds);
      });

      progressNodes.forEach((node) => {
        node.style.width = `${progress}%`;
      });

      inlineTimerNodes.forEach((node) => {
        node.textContent = formatted;
      });

      stickyTimerNodes.forEach((node) => {
        node.textContent = formatted;
      });

      nextTimerNodes.forEach((node) => {
        node.textContent = formatted;
      });
    };

    updateCountdown();
    intervalId = window.setInterval(updateCountdown, 1000);

    if (sticky && hero && 'IntersectionObserver' in window) {
      let heroIsOutOfView = false;
      let footerIsVisible = false;

      const footer = document.querySelector(
        '#footer, footer.footer, footer'
      );

      const syncStickyVisibility = () => {
        sticky.classList.toggle(
          'is-visible',
          heroIsOutOfView && !footerIsVisible
        );

        sticky.classList.toggle(
          'is-hidden-for-footer',
          footerIsVisible
        );
      };

      const heroObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            heroIsOutOfView = !entry.isIntersecting;
            syncStickyVisibility();
          });
        },
        { threshold: 0 }
      );

      heroObserver.observe(hero);

      if (footer) {
        const footerObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              footerIsVisible = entry.isIntersecting;
              syncStickyVisibility();
            });
          },
          { threshold: 0.01 }
        );

        footerObserver.observe(footer);
      }
    } else if (sticky && hero) {
      const footer = document.querySelector(
        '#footer, footer.footer, footer'
      );

      const toggleSticky = () => {
        const heroIsOutOfView =
          hero.getBoundingClientRect().bottom < 0;

        const footerIsVisible =
          footer &&
          footer.getBoundingClientRect().top < window.innerHeight;

        sticky.classList.toggle(
          'is-visible',
          heroIsOutOfView && !footerIsVisible
        );

        sticky.classList.toggle(
          'is-hidden-for-footer',
          Boolean(footerIsVisible)
        );
      };

      window.addEventListener('scroll', toggleSticky, {
        passive: true,
      });

      toggleSticky();
    }

    if ('IntersectionObserver' in window && reveals.length) {
      const revealObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;

            entry.target.classList.add('is-revealed');
            revealObserver.unobserve(entry.target);
          });
        },
        { threshold: 0.08 }
      );

      reveals.forEach((node) => revealObserver.observe(node));
    } else {
      reveals.forEach((node) =>
        node.classList.add('is-revealed')
      );
    }
  });
})();